import React from 'react';
// import { useNavigate } from 'react-router-dom';
import SportsNavStrip from './SportsNavStrip';
import MobileLiveBar from './MobileLiveBar';
// import Logo from '../../assets/img/logo-white.png';
import AnnouncementBar from '../../pages/LandingPage/AnnouncementBar';
import './header.css';

const PublicMobileHeader = ({ setIsSidebarOpen }) => {
  // const navigate = useNavigate();

  return (
    <div className="mobile-header-wrapper">
      {/* Dark Top Bar */}
      {/* <header className="mobile-header mobile-header--dark">
        <a href="/" className="mobile-header__logo">
          <img src={Logo} alt="IndoExch" />
        </a>
        <div className="mobile-header__spacer" />
        <div className="mobile-header__auth">
         
          <button
            className="mobile-header__auth-btn"
            onClick={() => navigate('/login')}
            type="button"
          >
            LOGIN
          </button>
        </div>
      </header> */}
 {/* <button
            className="mobile-header__auth-btn"
            onClick={() => navigate('/sign-up')}
            type="button"
          >
            SIGNUP
          </button> */}
      {/* Announcement Bar */}
      <AnnouncementBar />

      {/* Search Icon + Live Match Ticker */}
      <MobileLiveBar />

      {/* Sports Navigation */}
      <SportsNavStrip onMenuClick={() => setIsSidebarOpen && setIsSidebarOpen((prev) => !prev)} />
    </div>
  );
};

export default PublicMobileHeader;
